(function () {

   function initTjrCollectionCarousel(container) {

      const sliders = container.querySelectorAll('.tjr-collection-swiper');

      sliders.forEach((slider) => {

         if (slider.swiper) {
            slider.swiper.destroy(true, true);
         }

         const section = slider.closest('.tjr-collection-section');

         if (!section) return;

         const prevBtn = section.querySelector('.tjr-collection-prev');
         const nextBtn = section.querySelector('.tjr-collection-next');

         const desktopArrows =
            slider.dataset.desktopArrows === 'true';

         const mobileArrows =
            slider.dataset.mobileArrows === 'true';

         const isMobile =
            window.matchMedia('(max-width:749px)').matches;

         if (prevBtn && nextBtn) {

            if (isMobile) {

               if (!mobileArrows) {
                  prevBtn.style.display = 'none';
                  nextBtn.style.display = 'none';
               }

            } else {

               if (!desktopArrows) {
                  prevBtn.style.display = 'none';
                  nextBtn.style.display = 'none';
               }

            }

         }

         new Swiper(slider, {

            loop: true,

            speed: 600,

            grabCursor: true,

            observer: true,
            observeParents: true,

            navigation: {
               prevEl: prevBtn,
               nextEl: nextBtn
            },

            breakpoints: {

               0: {
                  slidesPerView: 1.15,
                  centeredSlides: true,
                  spaceBetween: 16
               },

               750: {
                  slidesPerView: 3,
                  centeredSlides: false,
                  spaceBetween: 24
               },

               1200: {
                  slidesPerView: 4,
                  centeredSlides: false,
                  spaceBetween: 24
               }

            }

         });

      });

   }

   document.addEventListener('DOMContentLoaded', function () {
      initTjrCollectionCarousel(document);
   });

   document.addEventListener('shopify:section:load', function (event) {
      initTjrCollectionCarousel(event.target);
   });

})();